import Image from 'next/image';
import { MecProduct } from '@adapters/bigcommerce/types/product';
import { resolveCompareImageSrc } from '@utils/comparison/resolveCompareImageSrc';

import styles from '../FranchiseCompareTable.module.scss';

interface FranchiseColumnProps {
  name: string;
  product?: MecProduct | null;
  imageUrl?: string;
  href?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  ariaLabel?: string;
}

const FranchiseColumn = ({
  name,
  product,
  imageUrl,
  href,
  onClick,
  ariaLabel,
}: FranchiseColumnProps) => {
  const src = resolveCompareImageSrc(imageUrl, product);

  const media = src ? (
    <Image
      src={src}
      alt={name}
      fill
      objectFit="contain"
      className={styles.productImage}
      sizes="(min-width: 720px) 304px, 187px"
    />
  ) : (
    <div className={styles.imagePlaceholder} aria-hidden="true" />
  );

  return (
    <div>
      <div className={styles.imageWrapper}>
        {href ? (
          <a
            href={href}
            onClick={onClick}
            className={styles.imageLink}
            aria-label={ariaLabel}
          >
            {media}
          </a>
        ) : (
          media
        )}
      </div>
    </div>
  );
};

export default FranchiseColumn;
